<div id="componentContainer" class="component-container">
  <div class="country-container">
    <div class="list-container">
      <div class="title">Select Company</div>
      @for (country of countryList; track country) {
        <div>
          <button class="country-button" (click)="onCountrySelect(country)">
            <img [src]="countryInfo[country].image" alt="flag_{{country}}" class="country-icon"/>
            <span>{{countryInfo[country].name}}</span>
          </button>
        </div>
      }
    </div>
  </div>
</div>